/** Money in the user's locale, e.g. "4 812,40 zł" for pl-PL / PLN. */
export function money(amount: number, currency: string, opts: { sign?: boolean; decimals?: boolean } = {}): string {
  const fmt = new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency || "PLN",
    minimumFractionDigits: opts.decimals === false ? 0 : 2,
    maximumFractionDigits: opts.decimals === false ? 0 : 2,
  }).format(Math.abs(amount));
  if (amount < 0) return `−${fmt}`;
  return opts.sign && amount > 0 ? `+${fmt}` : fmt;
}

/** Plain grouped number, e.g. "1 380". */
export function amountShort(n: number): string {
  return new Intl.NumberFormat(undefined, { maximumFractionDigits: 0 }).format(n);
}

export function greeting(name: string): string {
  const h = new Date().getHours();
  const part = h < 5 ? "Good evening" : h < 12 ? "Good morning" : h < 18 ? "Good afternoon" : "Good evening";
  return `${part}, ${name.split(" ")[0]}`;
}
